import Highcharts from 'highcharts/highstock';

/**
 * CustomChart for lbbw-am.de
 *
 * @author Florian Gutwald
 * Converted to Plain JS
 */
export class CustomChart {
  constructor(element, options = {}) {
    this.element = element;

    const defaults = {
      pieOptions: {
        chart: {
          height: 300
        },
        legend: {
          align: 'center',
          layout: 'horizontal',
          verticalAlign: 'bottom',
          legendX: 0,
          legendY: 0
        },
        series: {
          size: '30%',
          innerSize: '80%',
          centerTop: '10%',
          centerLeft: '50%'
        }
      }
    };

    // Deep merge für Optionen (simples Object.assign reicht hier nicht für verschachtelte Objekte)
    this.options = this._mergeDeep(defaults, options);

    this.init();
  }

  /**
   * Hilfsmethode für Deep Merge (Ersatz für $.extend(true, ...))
   */
  _mergeDeep(target, source) {
    for (const key in source) {
      if (source[key] instanceof Object && key in target) {
        Object.assign(source[key], this._mergeDeep(target[key], source[key]));
      }
    }
    Object.assign(target || {}, source);
    return target;
  }

  /**
   * Init method
   */
  init() {
    this.getChartParameter();

    // AMApp.CONSTANTS.BREAKPOINT.MD sollte global verfügbar sein
    if (window.innerWidth >= (window.AMApp?.CONSTANTS?.BREAKPOINT?.MD || 768)) {
      this.options.pieOptions.chart.height = 500;
      this.options.pieOptions.series.size = '50%';
      this.options.pieOptions.series.centerTop = '50%';
    }
  }

  /**
   * Get chart parameter
   */
  getChartParameter() {
    const file = this.element.dataset.chartFile;
    const type = this.element.dataset.chartType;
    const title = this.element.dataset.chartTitle;
    const subtitle = this.element.dataset.chartSubtitle;
    const container = this.element.id;

    this.initChart(file, container, type, title, subtitle);
  }

  /**
   * Init charts
   */
  initChart(file, container, type, title, subtitle) {
    switch (type) {
      case 'pie':
        this.createChartPie(file, container, title);
        break;
      case 'piedouble':
        this.createChartPieDouble(file, container, title, subtitle);
        break;
      case 'bar':
        this.createChartBar(file, container, title, subtitle);
        break;
      case 'column':
        this.createChartColumn(file, container, title, subtitle);
        break;
      case 'columnline':
        this.createChartColumnLine(file, container, title, subtitle);
        break;
      case 'columnstacking':
        this.createChartColumnStacking(file, container, title, subtitle);
        break;
    }
  }

  /**
   * Hilfsmethode zum Laden der CSV-Daten (Ersatz für $.get)
   */
  async _loadFileData(file) {
    try {
      const response = await fetch(file);
      return await response.text();
    } catch (error) {
      console.error('Fehler beim Laden der Chart-Daten:', error);
      return '';
    }
  }

  async createChartPie(file, container, title) {
        var that = this;
        var options = {
            styledMode: false,
            chart: {
                defaultSeriesType: 'pie',
                marginLeft: 0,
                height: this.options.pieOptions.chart.height,
                renderTo: container
            },
            credits: {
                enabled: false
            },
            title: {
                align: 'left',
                x: -10,
                style: { fontSize: '12px' },
                text: ''
            },
            subtitle: {
                align: 'left',
                x: -10,
                text: ''
            },
            legend: {
                title: {
                    text: '<b>' + title + '</b>'
                },
                align: this.options.pieOptions.legend.align,
                layout: this.options.pieOptions.legend.layout,
                verticalAlign: this.options.pieOptions.legend.verticalAlign,
                floating: true,
                borderWidth: 0,
                x: this.options.pieOptions.legend.legendX,
                y: this.options.pieOptions.legend.legendY
            },
            tooltip: {
                formatter: function () {
                    return '<b>' + this.point.name + ': </b>' + Highcharts.numberFormat(this.point.y, 1) + ' %';
                }
            },
            plotOptions: {
                pie: {
                    showInLegend: true,
                    allowPointSelect: true,
                    cursor: 'pointer',
                    shadow: false,
                    crop: false,
                    overflow: 'allow',
                    padding: 0,
                    dataLabels: {
                        formatter: function () {
                            return Highcharts.numberFormat(this.y, 1) + ' %';
                        },
                        distance: 15
                    }
                }
            },
            series: []
        };

        const data = await this._loadFileData(file);

            var lines = data.split('\n');
            var series = {
                data: [],
                center: [
                    that.options.pieOptions.series.centerLeft,
                    that.options.pieOptions.series.centerTop
                ],
                size: that.options.pieOptions.series.size,
                innerSize: that.options.pieOptions.series.innerSize,
                showInLegend: true
            };

            var i = 0;
            lines.forEach(function (line, lineNo) {
                var items = line.split(';');
                if (lineNo >= 0) {
                    if (!isNaN(items[1])) {
                        series.data.push({
                            type: 'pie',
                            name: items[0],
                            y: parseFloat(items[1])
                        });
                    }
                }
                i += 1;
            });

            options.series.push(series);
            options.chart.renderTo = container;

            var chart = new Highcharts.Chart(options);
        ;
    }

  async createChartPieDouble(file, container, title, subtitle) {
        var that = this;
        var options = {
            styledMode: false,
            chart: {
                defaultSeriesType: 'pie',
                marginLeft: 0,
                height: this.options.pieOptions.chart.height,
                renderTo: container
            },
            credits: {
                enabled: false
            },
            title: {
                align: 'left',
                x: -10,
                style: { fontSize: '12px' },
                text: ''
            },
            subtitle: {
                align: 'left',
                x: -10,
                text: ''
            },
            legend: {
                title: {
                    text: '<b>' + title + '</b>'
                },
                align: this.options.pieOptions.legend.align,
                layout: this.options.pieOptions.legend.layout,
                verticalAlign: this.options.pieOptions.legend.verticalAlign,
                floating: true,
                borderWidth: 0,
                x: this.options.pieOptions.legend.legendX,
                y: this.options.pieOptions.legend.legendY
            },
            tooltip: {
                formatter: function () {
                    return '<b>' + this.point.name + ': </b>' + Highcharts.numberFormat(this.point.y, 1) + ' ' + subtitle;
                }
            },
            plotOptions: {
                pie: {
                    showInLegend: true,
                    allowPointSelect: true,
                    cursor: 'pointer',
                    shadow: false,
                    crop: false,
                    overflow: 'allow',
                    padding: 0,
                    dataLabels: {
                        formatter: function () {
                            var breaker = '';
                            if (subtitle.length > 5) {
                                breaker = '<br />';
                            }
                            return Highcharts.numberFormat(this.y, 1) + breaker + ' ' + subtitle;
                        },
                        distance: 15
                    }
                }
            },
            series: []
        };

        const data = await this._loadFileData(file);

            var i = 0;
            var lines = data.split('\n');
            var series = {
                data: [],
                center: [
                    that.options.pieOptions.series.centerLeft,
                    that.options.pieOptions.series.centerTop
                ],
                size: that.options.pieOptions.series.size,
                innerSize: that.options.pieOptions.series.innerSize,
                showInLegend: true
            };

            lines.forEach(function (line, lineNo) {
                var items = line.split(';');
                if (lineNo >= 0) {
                    if (!isNaN(items[1])) {
                        series.data.push({
                            type: 'pie',
                            name: items[0],
                            y: parseFloat(items[1])
                        });
                    }
                }
                i += 1;
            });

            options.series.push(series);
            options.chart.renderTo = container;

            var chart = new Highcharts.Chart(options);
        ;
    }

  async createChartBar(file, container, titleLeft, titleRight) {
        var categories = [];
        var options = {
            chart: {
                renderTo: container,
                type: 'bar',
                animation: false
            },
            credits: {
                enabled: false
            },
            title: {
                text: titleLeft,
                align: 'left',
                x: -10
            },
            subtitle: {
                text: titleRight,
                align: 'left'
            },
            legend: { borderWidth: 0 },
            xAxis: [{
                categories: categories,
                reversed: true
            }, { // mirror axis on right side
                opposite: true,
                reversed: true,
                categories: ['', '', '', '', '', '', ''],
                linkedTo: 0,
                labels: {
                    enabled: true,
                    width: 50
                }
            }],
            yAxis: {
                title: {
                    text: null
                },
                labels: {
                    formatter: function () {
                        return (Math.abs(this.value)) + ' %';
                    }
                }
            },
            plotOptions: {
                series: {
                    stacking: 'normal'
                },
                bar: {
                    animation: false
                }
            },
            tooltip: {
                formatter: function () {
                    return this.series.name + ': ' + Highcharts.numberFormat(Math.abs(this.point.y), 1) + ' %';
                }
            },
            series: []
        };

        const data = await this._loadFileData(file);

            // Split the lines
            var lines = data.split('\n');

            // Iterate over the lines and add categories or series
            lines.forEach(function (line, lineNo) {
                var items = line.split(';');
                var series;

                // header line containes categories
                if (lineNo === 0) {
                    items.forEach(function (item, itemNo) {
                        if (itemNo > 0) {
                            options.xAxis[0].categories.push(item);
                        }
                    });
                } else if (lineNo === 1) {
                    // Leerzeilen ignorieren
                    if (items !== '' && items !== '\r') {
                        series = [{
                            data: []
                        }, { data: [] }];
                        items.forEach(function (item, itemNo) {
                            if (itemNo === 0) {
                                series[0].name = item;
                                series[0].type = 'bar';
                            } else {
                                series[0].data.push(parseFloat(item));
                            }
                        });

                        options.series.push(series[0]);
                    }
                } else if (lineNo === 2) {
                    if (items !== '' && items !== '\r') {
                        series = [{
                            data: []
                        }, { data: [] }];
                        items.forEach(function (item, itemNo) {
                            if (itemNo === 0) {
                                series[1].name = item;
                                series[1].type = 'bar';
                            } else {
                                series[1].data.push(parseFloat(item));
                            }
                        });

                        options.series.push(series[1]);
                        options.chart.renderTo = container;
                    }
                }
            });
            // Create the chart
            var chartBar = new Highcharts.Chart(options);
        ;
    }

  async createChartColumn(file, container, title, subtitle) {
        var options = {
            chart: {},
            credits: {
                enabled: false
            },
            title: {
                text: title,
                align: 'left',
                x: -10
            },
            subtitle: {
                text: subtitle,
                align: 'left'
            },
            tooltip: {
                formatter: function () {
                    return '<span>' + this.series.name + ':</span><br /><b>' + Highcharts.numberFormat(this.point.y, 3, ',', '.') + ' ' + subtitle + '</b>';
                }
            },
            legend: { borderWidth: 0 },
            xAxis: {
                categories: []
            },
            yAxis: {
                labels: {
                    formatter: function () {
                        return this.value;
                    }
                },
                title: {
                    text: ''
                }
            },
            series: []
        };


        const data = await this._loadFileData(file);

            // Split the lines
            var lines = data.split('\n');
            var series;

            // Iterate over the lines and add categories or series
            lines.forEach(function (line, lineNo) {
                var items = line.split(';');
                // header line containes categories
                if (lineNo === 0) {
                    items.forEach(function (item, itemNo) {
                        if (itemNo > 0) {
                            options.xAxis.categories.push(item);
                        }
                    });
                } else {
                    // the rest of the lines contain data with their name in the first position
                    // Leerzeilen ignorieren
                    if (items !== '' && items !== '\r') {
                        series = {
                            data: []
                        };
                        items.forEach(function (item, itemNo) {
                            if (itemNo === 0) {
                                series.name = item;
                            } else {
                                series.data.push(parseFloat(item));
                            }
                        });

                        options.series.push(series);
                        options.chart.renderTo = container;
                        options.chart.type = 'column';
                    }
                }
            });

            // Create the chart
            var chartColumns = new Highcharts.Chart(options);
        ;
    }

  async createChartColumnLine(file, container, titleLeft, titleRight) {
        var options = {
            chart: {},
            credits: {
                enabled: false
            },
            title: {
                text: '',
                align: 'left',
                x: -10
            },
            subtitle: {
                text: '',
                align: 'left'
            },
            tooltip: {
                formatter: function () {
                    return this.series.name + ': <b>' + Highcharts.numberFormat(this.point.y, 0, ',', '.') + '</b>';
                }
            },
            legend: { borderWidth: 0 },
            xAxis: {
                categories: []
            },
            yAxis: [{
                labels: {
                    formatter: function () {
                        return Highcharts.numberFormat(this.value, 0, ',', '.');
                    }
                },
                title: {
                    text: titleLeft
                }
            }, {
                labels: {
                    formatter: function () {
                        return Highcharts.numberFormat(this.value, 0, ',', '.');
                    }
                },
                title: {
                    text: titleRight
                },
                opposite: true,
                min: 0
            }],
            series: []
        };

        const data = await this._loadFileData(file);

            // Split the lines
            var lines = data.split('\n');
            var series;

            // Iterate over the lines and add categories or series
            lines.forEach(function (line, lineNo) {
                var items = line.split(';');

                // header line containes categories
                if (lineNo === 0) {
                    items.forEach(function (item, itemNo) {
                        if (itemNo > 0) {
                            options.xAxis.categories.push(item);
                        }
                    });
                } else if (lineNo === 1) {
                    // Leerzeilen ignorieren
                    if (items !== '' && items !== '\r') {
                        series = [{
                            data: []
                        }, { data: [] }];
                        items.forEach(function (item, itemNo) {

                            if (itemNo === 0) {
                                series[0].name = item;
                                series[0].type = 'column';
                            } else {
                                series[0].data.push(parseFloat(item));
                            }
                        });

                        options.series.push(series[0]);
                    }
                } else if (lineNo === 2) {
                    // Leerzeilen ignorieren
                    if (items !== '' && items !== '\r') {
                        series = [{
                            data: []
                        }, { data: [] }];
                        items.forEach(function (item, itemNo) {

                            if (itemNo === 0) {
                                series[1].name = item;
                                series[1].type = 'line';
                                series[1].yAxis = 1;
                            } else {
                                series[1].data.push(parseFloat(item));
                            }
                        });

                        options.series.push(series[1]);
                        options.chart.renderTo = container;
                    }
                }
            });

            // Create the chart
            var chart = new Highcharts.Chart(options);
        ;
    }

  async createChartColumnStacking(file, container, title, subtitle) {
        var options = {
            chart: {},
            credits: {
                enabled: false
            },
            title: {
                text: title,
                align: 'left',
                x: -10
            },
            subtitle: {
                text: subtitle,
                align: 'left'
            },
            tooltip: {
                formatter: function () {
                    return '<b>' + this.series.name + '</b>: ' + Highcharts.numberFormat(this.point.y, 0, ',', '.') + ' %';
                }
            },
            legend: { borderWidth: 0 },
            xAxis: {
                categories: []
            },
            yAxis: {
                labels: {
                    formatter: function () {
                        return this.value;
                    }
                },
                stackLabels: {
                    enabled: false
                },
                min: 0,
                max: 100
            },
            plotOptions: {
                column: {
                    stacking: 'normal',
                    dataLabels: {
                        enabled: true,
                        color: 'white',
                        formatter: function () {
                            return Highcharts.numberFormat(this.y, 1, ',', '.') + ' %';
                        }
                    }
                }
            },
            series: []
        };

        const data = await this._loadFileData(file);

            // Split the lines
            var lines = data.split('\n');

            // Iterate over the lines and add categories or series
            lines.forEach(function (line, lineNo) {
                var items = line.split(';');

                // header line containes categories
                if (lineNo === 0) {
                    items.forEach(function (item, itemNo) {
                        if (itemNo > 0) {
                            options.xAxis.categories.push(item);
                        }
                    });
                } else {
                    // Leerzeilen ignorieren
                    if (items !== '' && items !== '\r') {
                        var series = {
                            data: []
                        };
                        items.forEach(function (item, itemNo) {
                            if (itemNo === 0) {
                                series.name = item;
                            } else {
                                series.data.push(parseFloat(item));
                            }
                        });

                        options.series.push(series);
                        options.chart.renderTo = container;
                        options.chart.type = 'column';
                    }
                }
            });

            // Create the chart
            var chart = new Highcharts.Chart(options);
        ;
    }
}
